//外部引用了 此处不需要打包到主js内了
//import axios from 'axios'

//HCUser 存用户id tooken 等信息
//HCSecret 存手机号密码等
import Vue from 'vue'
import layers from 'layui-layer'
import { ImagePreview } from 'vant';

// const URL_ = window.location.origin=='https://sunsiltech.com'?'https://sunsiltech.com':'http://dev-sunsil.osforce.com.cn';
//接口路径
export default{
	_url:'https://www.pholtontech.com',
	showPhoto:function(num,datas){

		if(this.isMobile()){		//移动端
			var mobileList=[];
			datas.forEach((item,index)=>{
				mobileList.push(item.src);
			});
			ImagePreview({
			  images: mobileList,
			  startPosition: num,
			});
		}else{
			layers.photos({
		        // 其他配置...
		        closeBtn:1,
				shadeClose:false,
				anim: -1,
		        photos: {
		          "title": "FZ-production technology",
				   "start": num,
		          "data": datas
		        }
			});
		}

	},
	isMobile:function() {
    		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    		var mobile=/windows phone|iphone|ipad|ipod|android|blackberry|mini|windows ce|palm/i.test(
    			        userAgent.toLowerCase()
    		)

    		return mobile;
	}
}



//////////////////
// WEBPACK FOOTER
// ./static/common.js
// module id = null
// module chunks = 